export const supplierDetailsList = [
  'company.established',
  'company.weddingsHosted',
  'company.insurance',
  'company.teamSize',
];
